function normalizeApiMode(value) {
  const mode = String(value || '').trim().toLowerCase();
  if (mode === 'cloudflare' || mode === 'cf') return 'cloudflare';
  if (mode === 'local' || mode === 'mock') return 'local';
  return '';
}

function inferApiModeFromHost() {
  if (typeof window === 'undefined') return '';
  const hostname = window.location.hostname;
  if (
    hostname.includes('workers.dev') ||
    hostname.includes('pages.dev') ||
    hostname.includes('cloudflare')
  ) {
    return 'cloudflare';
  }
  return '';
}

const envMode = normalizeApiMode(process.env.VUE_APP_API_MODE);
const inferredMode = inferApiModeFromHost();
const apiMode = envMode || inferredMode || 'local';

let apiBaseUrl = process.env.VUE_APP_API_BASE_URL || '';
if (!apiBaseUrl) {
  apiBaseUrl = apiMode === 'local' ? 'http://localhost:3000' : '';
}

export const config = {
  apiMode,
  apiBaseUrl,
  appName: process.env.VUE_APP_APP_NAME || 'WhiteHorse',
  appVersion: '1.0.0'
};

export default config;
